<template>
  <v-card class="ma-4" max-width="474">
    <v-img height="400" :src="value.Image"></v-img>

    <v-card-title>{{ value.Title }}</v-card-title>

    <v-card-text>
<!--
      <v-row align="center" class="mx-0">
        <v-rating
          :value="4.5"
          color="amber"
          dense
          half-increments
          readonly
          size="14"
        ></v-rating>

        <div class="grey--text ml-4">4.5 (413)</div>
      </v-row>

      <div class="my-4 subtitle-1 black--text">
        $ • Blog, Noticias, Novidades
      </div>
-->      

      <div>
        {{ value.Summary }}
      </div>
    </v-card-text>

    <v-divider class="mx-4"></v-divider>

    <v-card-title></v-card-title>

    <v-card-text>
      <v-list two-line>
        <v-list-item>
          <v-list-item-avatar>
            <v-img :src="value.AuthorImg"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ value.Author }}</v-list-item-title>
            <v-list-item-subtitle>Autor</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>

    <v-card-actions class="align-self-end">
      <v-btn text @click="goLink(value.Url)">Continuar a leitura</v-btn>
<!--      
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>
-->      
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "uBlogPostCard",
  props: ["value", "ClassAd", "active", "dark"],
  components: {},
  created() {
    console.log("value", this.post);
  },
  methods: {
    goLink: function (newLink) {
      window.open(newLink, "_blank");
    }
  }
};
</script>
